export const ResourceTypeId = {
  OFFLOADING_EQUIPMENT: 'offloading_equipment',
  SENSORS: 'sensor',
  MATERIALS: 'material',
  // Matches the backend's fourth ResourceTypeInfo id and ResourceLinkTargets.Location -
  // the thing a location link points at and the resource type are the same concept.
  LOCATIONS: 'location',
} as const

export type ResourceTypeId =
  (typeof ResourceTypeId)[keyof typeof ResourceTypeId]

export const RESOURCE_TYPE_CODE_PREFIX: Record<string, string> = {
  [ResourceTypeId.OFFLOADING_EQUIPMENT]: 'EQP',
  [ResourceTypeId.MATERIALS]: 'MAT',
  [ResourceTypeId.LOCATIONS]: 'LOC',
}

export interface StaticFieldConfig {
  name: string
  label: string
  type: 'text' | 'number' | 'select'
  required?: boolean
  readOnly?: boolean
  width?: number
  isSearchable?: boolean
  isFacetable?: boolean
  placeholder?: string
}

/**
 * Non-static Location root columns that a resource form edits directly (not
 * stored in the `data` JSON). Like static fields, form values for these keys are
 * routed to root on save; unlike static fields they don't become table columns.
 */
export const RESOURCE_ROOT_FIELDS: Record<string, readonly string[]> = {
  [ResourceTypeId.OFFLOADING_EQUIPMENT]: ['iconName', 'color', 'parent'],
  [ResourceTypeId.LOCATIONS]: ['iconName', 'color', 'parent'],
}

export const RESOURCE_STATIC_FIELDS: Record<string, StaticFieldConfig[]> = {
  [ResourceTypeId.OFFLOADING_EQUIPMENT]: [
    {
      name: 'stxResourceId',
      label: 'ID',
      type: 'text',
      readOnly: true,
      width: 130,
      isSearchable: true,
    },
    {
      name: 'name',
      label: 'Name',
      type: 'text',
      required: true,
      width: 200,
      isSearchable: true,
      placeholder: 'Untitled',
    },
  ],
  [ResourceTypeId.LOCATIONS]: [
    {
      name: 'stxResourceId',
      label: 'ID',
      type: 'text',
      readOnly: true,
      width: 130,
      isSearchable: true,
    },
    {
      name: 'name',
      label: 'Name',
      type: 'text',
      required: true,
      width: 200,
      isSearchable: true,
      placeholder: 'Untitled',
    },
  ],
  [ResourceTypeId.SENSORS]: [
    {
      name: 'stxResourceId',
      label: 'ID',
      type: 'text',
      readOnly: true,
      width: 130,
      isSearchable: true,
    },
    {
      name: 'name',
      label: 'Name',
      type: 'text',
      required: true,
      width: 200,
      isSearchable: true,
      placeholder: 'Untitled',
    },
  ],
  [ResourceTypeId.MATERIALS]: [
    {
      name: 'stxResourceId',
      label: 'ID',
      type: 'text',
      readOnly: true,
      width: 130,
      isSearchable: true,
    },
    {
      name: 'name',
      label: 'Name',
      type: 'text',
      required: true,
      width: 200,
      isSearchable: true,
      placeholder: 'Untitled',
    },
  ],
}
